import PaymentOrderFeeState from "@/models/Accounts/Shared/PaymentOrders/PaymentOrderFeeState";

export default (val: PaymentOrderFeeState) => {
    let returnVal = "Undefined";
    switch (val) {
        case PaymentOrderFeeState.NoFee:
            returnVal = "No Fee"
            break;
        case PaymentOrderFeeState.FeePending:
            returnVal = "Fee Pending"
            break;
        case PaymentOrderFeeState.FeePaid:
            returnVal = "Fee Paid"
            break;
        case PaymentOrderFeeState.FeeFailed:
            returnVal = "Fee Failed"
            break;
    }
    return returnVal;
}